<h2 mat-dialog-title class="dialog-country-upsert__title">{{ data.title }}</h2>

<mat-dialog-content>
  @if (data.message) {
    <p class="dialog-country-upsert__message">{{ data.message }}</p>
  }

  <form
    id="countryUpsertForm"
    class="dialog-country-upsert__form"
    [formGroup]="form"
    (ngSubmit)="submit()"
  >
    <div class="dialog-country-upsert__field">
      <ui-molecule-input
        textId="countryName"
        formControlName="name"
        [label]="'countries.form.name.label' | translate"
        [placeholder]="'countries.form.name.placeholder' | translate"
        [required]="true"
        [maxLength]="nameMax"
        [errorMessage]="nameError"
      >
      </ui-molecule-input>
    </div>

    @if (errorMessage) {
      <div class="dialog-country-upsert__error">
        <ui-atom-text type="small" [text]="errorMessage"></ui-atom-text>
      </div>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-country-upsert__actions">
  <ui-atom-button
    type="button"
    rules="main"
    styling="outlined"
    [withShadow]="false"
    [text]="'common.cancel' | translate"
    [disabled]="isLoading"
    (buttonClick)="onCancel()"
  >
  </ui-atom-button>

  <ui-atom-button
    type="button"
    rules="main"
    styling="filled"
    [withShadow]="true"
    [text]="data.mode === 'edit' ? ('common.save' | translate) : ('common.create' | translate)"
    [disabled]="isLoading || form.invalid"
    (buttonClick)="submit()"
  >
  </ui-atom-button>
</mat-dialog-actions>
